/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_buf_recipe = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buffer`)
};

const es_buf_recipe = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buffer`)
};

const de_buf_recipe = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puffer`)
};

const nl_buf_recipe = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buffer`)
};

const fr_buf_recipe = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tampon`)
};

const it_buf_recipe = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buffer`)
};

const pt_br2_buf_recipe = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tampão`)
};

const pt_buf_recipe = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tampão`)
};

const ja_buf_recipe = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バッファー`)
};

const zh_buf_recipe = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`缓冲液`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const buf_recipe = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.buf_recipe(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("buf_recipe", locale)
	if (locale === "en") return en_buf_recipe(inputs)
	if (locale === "es") return es_buf_recipe(inputs)
	if (locale === "de") return de_buf_recipe(inputs)
	if (locale === "nl") return nl_buf_recipe(inputs)
	if (locale === "fr") return fr_buf_recipe(inputs)
	if (locale === "it") return it_buf_recipe(inputs)
	if (locale === "pt-BR") return pt_br2_buf_recipe(inputs)
	if (locale === "pt") return pt_buf_recipe(inputs)
	if (locale === "ja") return ja_buf_recipe(inputs)
	return zh_buf_recipe(inputs)
};